import React, { Component } from "react";
import { connect } from "react-redux";
import { Button } from "antd";

import { Header, Nav, HamburgerMenu } from "./components";

import { loginUserCheck, logoutUser, userAdd } from "../redux/actions";

class AdminAddUser extends Component {
  constructor() {
    super();
    this.state = {
      rank: 1,
      user_id: "",
      firstname: "",
      lastname: "",
      toggleMenu: false,
    };
  }

  componentWillMount() {
    this.props.loginUserCheck();
  }

  _handleMenu() {
    this.setState({ toggleMenu: !this.state.toggleMenu });
  }

  _handleLogout() {
    this.props.logoutUser();
  }

  _onHandleChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  _onSubmit() {
    let user = {
      // user_id: (new Date()).getTime().toString(),
      user_id: this.state.user_id,
      rank: this.state.rank,
      firstname: this.state.firstname,
      lastname: this.state.lastname,
      point: 0,
      status: 0,
      line_id: "",
      fb_id: "",
      pic: "",
      created_date: new Date().getTime().toString(),
      created_by: this.props.user,
    };
    if (this.state.firstname && this.state.lastname) {
      this.props.userAdd(user);
    } else {
      alert("Please fill in a form...");
    }
  }

  render() {
    if (!this.props.user) return <div></div>;
    return (
      <div>
        <Header name={this.props.user} logout={() => this._handleLogout()} />
        <div className="admin-adduser">
          <Nav active="users" />
          <div
            className={this.state.toggleMenu ? "content moveover" : "content"}
          >
            <div className="content-inner">
              <HamburgerMenu onClick={() => this._handleMenu()} />
              <div className="title">
                <h2>ลูกค้า : เพิ่มลูกค้าใหม่</h2>
              </div>
              <div className="info">
                <div className="adjust">
                  <div className="name">
                    <form>
                      <div className="type">
                        <p>ระดับลูกค้า</p>
                        <select
                          name="rank"
                          onChange={(event) => this._onHandleChange(event)}
                        >
                          <option value={1}>1</option>
                          <option value={2}>2</option>
                          <option value={3}>3</option>
                          <option value={4}>4</option>
                          <option value={5}>5</option>
                        </select>
                      </div>
                      <p>User ID</p>
                      <input
                        type="text"
                        name="user_id"
                        onChange={(event) => this._onHandleChange(event)}
                      ></input>
                      <p>ชื่อ</p>
                      <input
                        type="text"
                        name="firstname"
                        onChange={(event) => this._onHandleChange(event)}
                      ></input>
                      <p>นามสกุล</p>
                      <input
                        type="text"
                        name="lastname"
                        onChange={(event) => this._onHandleChange(event)}
                      ></input>
                    </form>
                  </div>
                  <div className="action-button">
                    <Button type="primary" onClick={() => this._onSubmit()}>
                      บันทึก
                    </Button>
                    <Button onClick={() => window.history.back()}>กลับ</Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ auth }) => {
  const { user } = auth;
  return { user };
};

export default connect(mapStateToProps, {
  loginUserCheck,
  logoutUser,
  userAdd,
})(AdminAddUser);
